import React from 'react';
import {
  setIsViewOpened,
  setPreselectedConfiguration,
} from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getLastLoadedView } from '@/store-selectors';
import { useGetQueryBuilderSummarizeConfig } from '@/features/queryConfig/hooks/useGetQueryBuilderSummarizeConfig';

export const useDispatchUpdatesToMetricConfig = () => {
  const { data } = useGetQueryBuilderSummarizeConfig();
  const lastLoadedView = useSelector(getLastLoadedView);
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (data) {
      dispatch(setPreselectedConfiguration(data));
    }
  }, [data]);

  React.useEffect(() => {
    dispatch(setIsViewOpened(!!lastLoadedView));
  }, [lastLoadedView]);
};
